import { API_URL, apiConfig } from "./api-config.js";

const loginForm = document.querySelector('form#login_customer');
const loginNotification = loginForm.querySelector('.form-error');
const loginSuccessNotification = loginForm.querySelector('.form-success');
const loginNotifDescription = loginNotification.querySelector('.form-error-description');
const loginSuccessDescription = loginSuccessNotification.querySelector('.form-message--successs')
const loginEmailForm = loginForm.querySelector('[name="customer[email]"]');
const loginPasswordForm = loginForm.querySelector('[name="customer[password]"]');
const loginButton = loginForm.querySelector('button[type="submit"]');

const hiddenForm = document.querySelector('form#customer_login');
const errorHiddenForm = hiddenForm.querySelector('.error-notification');
const emailInput = hiddenForm.querySelector('[name="customer[email]"]');
const passwordInput = hiddenForm.querySelector('[name="customer[password]"]');

document.addEventListener('DOMContentLoaded', () => {
  const isRegistered = sessionStorage.getItem('registration_success');

  if (isRegistered === 'true') {
    sessionStorage.removeItem('registration_success');

    loginSuccessNotification.classList.remove('hidden');
    loginSuccessDescription.textContent = "Your account has been registered. Please check your email dan click the verification link to continue login."
  }
})

function initTriggerLoginButton() {
  resetNotificationError();

  if (errorHiddenForm) {
    const listErrorMessages = errorHiddenForm.querySelectorAll('.errors ul li');
    const textErrorMessages = Array.from(listErrorMessages).map(error => error.textContent);
    const formatError = textErrorMessages.join('<br>');

    loginNotification.classList.remove('hidden');
    loginNotification.classList.add('alert--error');
    loginNotifDescription.classList.add('form-message--error');

    loginNotifDescription.innerHTML = formatError
  }

  if (loginForm) {
    loginForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      setLoadingState(true);
      resetNotificationError();

      try {
        const email = loginEmailForm.value;
        const password = loginPasswordForm.value;

        const payload = { email, password }

        const customerValidate = await fetch(`${API_URL}/customer/validate?email=${email}`, {
          method: "GET",
          headers: apiConfig.getHeaders()
        })

        if (customerValidate.ok) {
          const response = await customerValidate.json();
          
          if (response.code == "ERROR") {
            setLoadingState(false);
            if (response.subCode == "E-CUST-DATA-NOT-READY") {
              loginNotification.classList.add('alert--warning');
              loginNotification.classList.remove('hidden');
              loginNotifDescription.classList.add('form-message--warning');
              loginNotifDescription.textContent = "Please wait, your account will be ready soon";
            } else if (response.subCode == "E-CUST-NOT-FOUND") {
              loginNotification.classList.add("alert--error");
              loginNotification.classList.remove('hidden');
              loginNotifDescription.classList.add('form-message--error');
              loginNotifDescription.textContent = "Incorrect email or password";
            } else if (response.subCode == "E-CUST-EMAIL-NOT-VERIFIED") {
              loginNotification.classList.add('alert--warning');
              loginNotification.classList.remove('hidden');
              loginNotifDescription.classList.add('form-message--warning');
              loginNotifDescription.textContent = "Your email has not been verified yet. Please check your email for welcome/verification email.";
            } else {
              loginNotification.classList.add("alert--error");
              loginNotification.classList.remove('hidden');
              loginNotifDescription.classList.add('form-message--error');
              loginNotifDescription.textContent = `Error: ${response.subCode}`;
            }
          } else if (response.code == "OK") {
            emailInput.value = email;
            passwordInput.value = password;

            handleFormSubmission(hiddenForm)
          }
        }
      } catch (error) {
        setLoadingState(false);
        console.log(error);
      }
    }, false)
  }
}

function setLoadingState(isLoading) {
  loginButton.disabled = isLoading;

  if (!isLoading) {
    loginEmailForm.removeAttribute("readonly");
    loginPasswordForm.removeAttribute("readonly");
  } else {
    loginEmailForm.setAttribute("readonly", true);
    loginPasswordForm.setAttribute("readonly", true);
  }
}

function resetNotificationError() {
  loginNotification.classList.add('hidden');
  loginNotification.classList.remove('alert--error', 'alert--warning');
  loginNotifDescription.classList.remove('form-message--warning', 'form-message--error');
  loginNotifDescription.textContent = '';
}

function handleFormSubmission(form) {
  if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
      window.Shopify.captcha.protect(form, () => {
        submitFormData(form);
      });
  } else {
    submitFormData(form);
  }
}

function submitFormData(form) {
  form.submit()
}

initTriggerLoginButton()